window.askaronUI = window.askaronUI ?? {};

window.askaronUI.promoParallax = {
  smoothingMs: 100,
  init() {
    const images = [...document.querySelectorAll('[data-askr-promo-parallax]')];
    if (!images.length || this.initialized) return;
    this.initialized = true;

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const frontStates = new Map(images.map((image) => [image, {
      wrap: image.querySelector('.p-promo-conditions__image-front-wrap'),
      offset: null
    }]));
    let frame = null;
    let lastTime = null;

    const update = (time) => {
      frame = null;
      const elapsed = lastTime === null ? 1000 / 60 : time - lastTime;
      const blend = 1 - Math.exp(-elapsed / Math.max(1, this.smoothingMs));
      let animating = false;
      images.forEach((image) => {
        const state = frontStates.get(image);
        if (reducedMotion.matches || !image.getClientRects().length) {
          state.offset = null;
          image.style.removeProperty('--promo-parallax-offset');
          image.style.removeProperty('--promo-front-parallax-offset');
          return;
        }

        const rect = image.getBoundingClientRect();
        const offset = Math.max(0, Math.min(window.innerHeight - rect.top, window.innerHeight + rect.height));
        image.style.setProperty('--promo-parallax-offset', `${offset.toFixed(2)}px`);
        // До срабатывания sticky блок находится у верхнего края image.
        const frontOffset = state.wrap ? Math.max(0, state.wrap.getBoundingClientRect().top - rect.top) : 0;
        state.offset = state.offset === null ? frontOffset : state.offset + (frontOffset - state.offset) * blend;
        if (Math.abs(frontOffset - state.offset) < 0.1) {
          state.offset = frontOffset;
        } else {
          animating = true;
        }
        image.style.setProperty('--promo-front-parallax-offset', `${state.offset.toFixed(2)}px`);
      });
      lastTime = animating ? time : null;
      if (animating) frame = window.requestAnimationFrame(update);
    };

    const scheduleUpdate = () => {
      if (frame === null) frame = window.requestAnimationFrame(update);
    };

    window.addEventListener('scroll', scheduleUpdate, { passive: true });
    window.addEventListener('resize', scheduleUpdate);
    window.addEventListener('load', scheduleUpdate);
    reducedMotion.addEventListener('change', scheduleUpdate);
    scheduleUpdate();
  }
};

$(document).ready(() => {
  window.askaronUI.promoParallax.init();
});